import { Draggable } from "@hello-pangea/dnd";
import { OrderRequestData } from "./Domain/RemoteOrderRequests.types";
import { Box, Card, type Theme, useTheme } from "@mui/material";
import { OrderRequestCardItem } from "./partial/OrderRequestCardItem.partial";
import { ServiceType } from "../../../features/Booking-Form/typings/booking-service-administration.types";
import { isLockedOrderRequestColumn } from "./functions/orderRequestListContents.functions";

type DraggableCardItemProps = {
  item: OrderRequestData;
  index: number;
  itemIndex: number;
  filterByType: ServiceType[];
  setSelectedOrder: (o: OrderRequestData) => void;
  isArchive: boolean;
  isBookingCancelled: boolean;
};

export const orderRequestKanbanCardPressSx = (
  isDragging: boolean,
  isDragDisabled: boolean,
  theme: Theme
) => ({
  m: "8px 16px 16px 16px",
  border: isDragging ? `3px solid ${theme.palette.primary.main}` : "none",
  userSelect: "none",
  cursor: isDragDisabled ? "pointer" : "grab",
  transition: theme.transitions.create(["box-shadow", "transform"], {
    duration: theme.transitions.duration.shortest
  }),
  "&:active": {
    boxShadow: "inset 0 2px 6px rgba(0, 0, 0, 0.18)",
    transform: "scale(0.985)"
  }
});

export function DraggableCardItem({
  item,
  index,
  itemIndex,
  filterByType,
  setSelectedOrder,
  isArchive,
  isBookingCancelled
}: Readonly<DraggableCardItemProps>) {
  const theme = useTheme();
  const isDragDisabled = isLockedOrderRequestColumn(itemIndex);

  return (
    <Draggable
      key={item.id}
      draggableId={String(item.id)}
      index={index}
      isDragDisabled={isDragDisabled}
    >
      {(provided, snapshot) => (
        <Card
          sx={orderRequestKanbanCardPressSx(snapshot.isDragging, isDragDisabled, theme)}
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          style={{ ...provided.draggableProps.style }}
        >
          <Box
            data-testid={`draggable-item-${item.bookingId}`}
            onClick={() => setSelectedOrder(item)}
            sx={{ cursor: "inherit" }}
          >
            <OrderRequestCardItem
              item={item}
              isSelected={false}
              isDetailLoading={false}
              filterByType={filterByType}
              isArchive={isArchive}
              isBookingCancelled={isBookingCancelled}
            />
          </Box>
        </Card>
      )}
    </Draggable>
  );
}
